<script>
import Loading from "../common/loading.vue";
import LoginBanner from "./login-banner.vue";
import LoginContainer from "./login-container.vue";
import LoginWindow from "./login-window.vue";
import LoginWindowFooter from "./login-window-footer.vue";
import LoginFooterIcons from "./login-footer-icons.vue";
import LoginEmailField from "./login-email-field.vue";
import LoginForm from "./login-form.vue";
import LoginSubmitButton from "./login-submit-button.vue";

export default {
    name: "forget-password",
    components: {
        LoginSubmitButton,
        LoginForm,
        LoginEmailField, LoginFooterIcons, LoginWindowFooter, LoginWindow, LoginContainer, LoginBanner, Loading},
    props: {
        versionText: String,
        appKey: String,
        csrfToken: String,
        forgetPasswordUrl: String,
        session: {},
        loginUrl: String,
        registerUrl: String,
        registrationActiveString: String
    },
    provide() {
        return {
            appKey: this.appKey,
        }
    },
    data() {
        return {
            loading: false,
            emailValid: false
        }
    },
    computed: {
        translations() {
            return {
                email: Lang.langGet('Email address'),
                title: Lang.langGet('Forgot password'),
                subTitle: Lang.langGet('Enter your email address that you used to register. We\'ll send you an email with a link to reset your password.'),
                message: Lang.langGet('If a user with this email address exists, we have sent a password reset link!'),
                submit: Lang.langGet('Submit'),
                login: Lang.langGet('Login'),
                register: Lang.langGet('Register'),
            }
        },
        registrationActive() {
            return this.registrationActiveString.includes('1');
        },
        displayMessage() {
            return _.isString(this.session) && this.session !== '';
        }
    },
    methods: {
        handleSubmit() {
            this.loading = true;
        },
        handleValidity(prop, value) {
            this.emailValid = value;
        }
    }
}
</script>

<template>
    <login-container>
        <loading :loading="loading"/>
        <login-window>
            <login-banner :title="translations.title" :subTitle="translations.subTitle"/>

            <div v-if="displayMessage" class="alert alert-success">
                {{ session }}
            </div>

            <login-form :url="forgetPasswordUrl">
                <input type="hidden" name="_token" :value="csrfToken" autocomplete="off" />
                <login-email-field :validateOnBlur="false" @valid="handleValidity" />
                <login-submit-button @click="handleSubmit" :disabled="!emailValid">
                    {{ translations.submit }}
                </login-submit-button>
            </login-form>

            <login-window-footer :versionText="versionText">
                <a :href="loginUrl" class="">{{ translations.login }}</a>
                <a v-if="registrationActive" :href="registerUrl" class="">{{ translations.register }}</a>
            </login-window-footer>
        </login-window>
        <login-footer-icons url="https://easescreen.com/"/>
    </login-container>
</template>

